<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="采集类型"
                    required
                  >
                    <el-checkbox-group
                      v-model="dialogAddEditViewForm.sortCheck"
                      @change="changeSortFun"
                    >
                      <el-checkbox
                        v-for="item in sortOptions"
                        :key="item.data"
                        :label="item.data"
                      >
                        {{ item.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-for="(itemObj,index) in collectList"
            :key="index"
            class="modal-box"
          >
            <h3 class="modal-title">
              {{ itemObj.sortName }}
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="采集时间"
                    required
                  >
                    <el-select
                      v-model="itemObj.collectionPlan"
                      placeholder="请选择采集时间"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in collectionPlanOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="采集频率"
                    required
                  >
                    <el-select
                      v-model="itemObj.collectionFrequency"
                      placeholder="请选择采集频率"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in collectionFrequencyOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="采集人"
                    required
                  >
                    <el-select
                      v-model="itemObj.collectionUserId"
                      filterable
                      placeholder="请选择采集人"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in collectionUserOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="采集品规"
                    required
                  >
                    <el-checkbox-group v-model="itemObj.collectionProductCheck">
                      <el-checkbox
                        v-for="item in itemObj.collectionProductOptions"
                        :key="item.data"
                        :label="item.data"
                      >
                        {{ item.label }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { saveOrUpdateStoreInfoCollectSettingApi, findStoreInfoCollectSettingByStoreIdApi } from '@/api/store'
import { findRetailMonitoringProductByCityIdApi } from '@/api/retailMonitoringProductSetting'
import { loadUserSelectDataByUserTypeApi } from '@/api/user'
// API
import { listDictApi } from '@/api/v2/dict';
import { listSurveyProductSettingApi } from '@/api/v2/surveyProductSetting'


export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
    cityId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
      },
      collectionPlanOptions: [],
      collectionFrequencyOptions: [],
      collectionUserOptions: [],
      sortOptions: [{ label: '单品动销', data: 1 }, { label: '零售监测', data: 2 }],
      collectList: [],
      productSingleOptions: [], //单品品规
      productMonitorOptions: [] //零售监测品规
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.collectionPlanOptions = []
        this.collectionFrequencyOptions = []
        this.collectionUserOptions = []
        this.collectList = []
        this.productSingleOptions = []
        this.productMonitorOptions = []
        this.dialogAddEditViewForm = {
          storeId: null,
          sortCheck: []
        }
        this.initCollectUserSelectData()
        this.initVisitPlanSelectData()
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      findStoreInfoCollectSettingByStoreIdApi({ storeId: this.dataId }).then(res => {
        const { data } = res
        this.dialogAddEditViewForm.storeId = this.dataId
        if (data.length > 0) {
          data.forEach(item => {
            this.dialogAddEditViewForm.sortCheck.push(item.sort)
            let collectItem = { sortName: item.sortStr, sortId: item.sort, collectionPlan: item.collectionPlan, collectionFrequency: item.collectionFrequency, collectionUserId: item.collectUserId, collectionProductCheck: [], collectionProductOptions: [] }
            item.storeInfoCollectDetails.forEach(detailItem => {
              collectItem.collectionProductCheck.push(detailItem.productId)
            })
            if (item.sort === 1) {
              collectItem.collectionProductOptions = this.productSingleOptions
            } else {
              collectItem.collectionProductOptions = this.productMonitorOptions
            }
            this.collectList.push(collectItem)
          })
        }
        this.loading = false
      })
    },
    // 初始采集时间下拉数据
    initVisitPlanSelectData () {
      let _this = this;
      listDictApi({ types: '38,44' }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          if (item.type === 38) {
            _this.collectionPlanOptions.push({ label: item.optionLabel, data: Number(item.optionValue) })
          } else if (item.type === 44) {
            _this.collectionFrequencyOptions.push({ label: item.optionLabel, data: Number(item.optionValue) })
          }
        })
        _this.loadSurveyProductSelectData(_this.cityId)
      })
    },
    // 初始单品采集品规下拉数据
    loadSurveyProductSelectData (cityId) {
      let _this = this;
      listSurveyProductSettingApi({ status: 1, cityId: cityId }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.productSingleOptions.push({ label: item.name, data: item.id, priceRangeId: 0 })
        })
        _this.initMonitorProductSelectData(_this.cityId)
      })
    },
    // 初始监测采集品规下拉数据
    initMonitorProductSelectData (cityId) {
      findRetailMonitoringProductByCityIdApi({ cityId: cityId, storeId: this.dataId }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.productMonitorOptions.push({ label: item.productName, data: item.productId, priceRangeId: item.priceRangeId })
        })
        this.initPageData()
      })
    },
    // 初始采集人下拉数据
    initCollectUserSelectData () {
      loadUserSelectDataByUserTypeApi().then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.collectionUserOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择类型回调
    changeSortFun (val) {
      this.collectList = []
      if (val.length > 0) {
        val.forEach(sortId => {
          let selectSort = this.sortOptions.find(sortItem => {
            return sortItem.data === sortId
          })
          let collectItem = { sortName: selectSort.label, sortId: sortId, collectionPlan: null, collectionFrequency: 1, collectionUserId: null, collectionProductCheck: [], collectionProductOptions: [] }
          if (sortId === 1) {
            collectItem.collectionProductOptions = this.productSingleOptions
          } else {
            collectItem.collectionProductOptions = this.productMonitorOptions
          }
          this.collectList.push(collectItem)
        })
      }
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      if (this.dialogAddEditViewForm.sortCheck.length === 0) {
        this.$message({
          message: '请选择采集类型',
          type: 'warning'
        })
        return false
      }
      let settingData = []
      let hasPlanError = false
      let hasFrequencyError = false
      let hasUserError = false
      let hasProductError = false
      this.collectList.forEach(item => {
        if (item.collectionPlan === null || item.collectionPlan === '' || item.collectionPlan === undefined) {
          hasPlanError = true
        }
        if (item.collectionFrequency === null || item.collectionFrequency === '' || item.collectionFrequency === undefined) {
          hasFrequencyError = true
        }
        if (item.collectionUserId === null || item.collectionUserId === '' || item.collectionUserId === undefined) {
          hasUserError = true
        }
        if (item.collectionProductCheck.length === 0) {
          hasProductError = true
        }
        let selectUser = this.collectionUserOptions.find(userItem => {
          return userItem.data === item.collectionUserId
        })
        let itemData = { sort: item.sortId, collectionFrequency: item.collectionFrequency, collectionPlan: item.collectionPlan, collectUserId: item.collectionUserId, collectUserName: selectUser.label }
        let detailList = []
        item.collectionProductCheck.forEach(productId => {
          let selectProduct = null
          if (item.sortId === 1) {
            selectProduct = this.productSingleOptions.find(userItem => {
              return userItem.data === productId
            })
          } else {
            selectProduct = this.productMonitorOptions.find(userItem => {
              return userItem.data === productId
            })
          }
          if (selectProduct !== null && selectProduct !== undefined)
            detailList.push({ priceRangeId: selectProduct.priceRangeId, productName: selectProduct.label, productId: productId })
        })
        itemData.detailList = detailList
        settingData.push(itemData)
      })
      if (hasPlanError) {
        this.$message({
          message: '请选择采集时间',
          type: 'warning'
        })
        return false
      }
      if (hasFrequencyError) {
        this.$message({
          message: '请选择采集频率',
          type: 'warning'
        })
        return false
      }
      if (hasUserError) {
        this.$message({
          message: '请选择采集人',
          type: 'warning'
        })
        return false
      }
      if (hasProductError) {
        this.$message({
          message: '请选择采集品规',
          type: 'warning'
        })
        return false
      }
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定保存采集设置信息', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true

              this.dialogAddEditViewForm.settingData = JSON.stringify(settingData)
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateStoreInfoCollectSettingApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
